import { render, staticRenderFns } from "./PageEditLayout.vue?vue&type=template&id=d4f27838&scoped=true"
import script from "./PageEditLayout.vue?vue&type=script&lang=js"
export * from "./PageEditLayout.vue?vue&type=script&lang=js"
import style0 from "./PageEditLayout.vue?vue&type=style&index=0&id=d4f27838&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f27838",
  null
  
)

/* custom blocks */
import block0 from "./PageEditLayout.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports